import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef, useContext, useEffect } from 'react';
// @mui
import { Box, Paper, styled, Typography } from '@mui/material';
import { headerContext } from 'contexts/HeaderContext';
import { BreadCrumbs } from './Breadcrumbs';

// ----------------------------------------------------------------------

export const Page = forwardRef(({ children, title = '', meta, paths, ...other }, ref) => {
  const ctx = useContext(headerContext);
  const { onTitleChange } = ctx;

  useEffect(() => {
    onTitleChange(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return (
    <>
      <Helmet>
        <title>{`${title} | بیز`}</title>
        {meta}
      </Helmet>

      {paths?.length > 0 && <BreadCrumbs paths={paths} />}

      <Box ref={ref} {...other}>
        <StyledPaper sx={{ my: 3 }}>{children}</StyledPaper>
      </Box>
    </>
  );
});

export const PageTitle = ({ title, size }) => (
    <Typography fontSize={!size ? 20 : size} fontWeight={700} sx={{ mb: 3 }}>
      {title}
    </Typography>
  );

const StyledPaper = styled(Paper)(() => ({
  background: '#FFFFFF',
  borderRadius: '16px',
  border: '1px solid #F1F3F4',
  width: 'min(100%,98vw)',
  minHeight: 698,
  height: '100%',
  padding: '3rem',
  boxShadow: '0px 12px 22px rgba(0, 0, 0, 0.09)',
  margin: '0 auto',
}));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
  paths: PropTypes.array,
};
